import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { IClient } from '../../../clients-page/clients/clients.interface';
import { AuthService } from '../../../../shared/services/auth.service';
import { UtilsService } from '../../../../shared/services/utils.service';
import { Broadcaster } from '../../../../shared/components/broadcaster.component';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { TaskRequestsService } from '../../../task-requests-page/task-requests/task-requests.service';
import { ClientsService } from '../../../clients-page/clients/clients.service';
import { ClientsModalComponent } from '../../../clients-page/clients/clients-modal/clients-modal.component';


let self: any;

@Component({
  selector: 'app-task-requests-detail',
  templateUrl: './match-client-modal.component.html',
  styleUrls: ['./match-client-modal.component.css']
})
export class MatchClientModalComponent implements OnInit {
  client: any;
  loading: boolean = true;
  isDev!: boolean;
  dialog: MatDialogRef<any>;
  clients: IClient[] = [];

  filter: any;

  constructor(
    private _ClientsService: ClientsService,
    private _TaskRequestsService: TaskRequestsService,
    private _broadcaster: Broadcaster,
    private _dialogService: DialogService,
    public dialogRef: MatDialogRef<any>,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private router: Router,
    private _route: ActivatedRoute,
    private _AuthService: AuthService,
    private _UtilService: UtilsService,
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit() {
    this.filter = {
      company: this._AuthService.companyId(),
      filters: {
        term: '',
      },
    }
    this.isDev = this._AuthService.isRole('dev');
    this.filter.company = this._AuthService.companyId();
    this.getClients();
  }


  getClients() {
    this.loading = true
    this.filter.filters.term = this.client.firstname+" "+this.client.lastname+" "+this.client.nit+" "+this.client.phone
    this._ClientsService.getClientsSimilar(this.filter).subscribe((clients: any) => {
      console.log(clients)
      this.clients = _.concat(this.clients, clients.map((el: IClient) => {
        el.addresses?.forEach(add => {
          const aux = (add.address || '').split(',');
          add.address = (aux[0] || '') + ', ' + (aux[1] || '');
          return add;
        })
        return el;
      }));
      this.loading = false;
    })

    // this._ClientsService.getClients(this.filter).subscribe((clients: any) => {
    //   // console.log(clients)
    //   this.clients = _.concat(this.clients, clients.map((el: IClient) => {
    //     el.addresses.forEach(add => {
    //       const aux = (add.address || '').split(',');
    //       add.address = (aux[0] || '') + ', ' + (aux[1] || '');
    //       return add;
    //     })
    //     return el;
    //   }));
    //   this.loading = false;
    // })
  }

  selectClient(client: IClient){
    this.dialog.close(client);
  }

  openTaskRequestClient() {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '1300px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(ClientsModalComponent, config);
    self.dialogRef.componentInstance.clientTaskRequest = this.client;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      console.log(result)
      if (result) this.dialog.close(result);
    });
  }

}